import { connect } from 'react-redux'
import { useEffect, useState, useRef } from 'react'
import { loadGraphDataFromNodes } from 'Services/GraphUtils'
import { withRouter } from 'react-router'
import initScene from './initScene'
import WeaverService from 'Services/WeaverService'
import ForceGraphVR from '3d-force-graph-vr'
import GameItemLocator from './GameItemLocator'

Gijsplorer = ({ currentProject, history }) ->

  Graph = useRef(undefined)
  locator = useRef(undefined)
  requestRef = useRef()

  [gameIsStopped, setGameIsStopped] = useState(false)

  useEffect( ->
    ( ->
      try
        q = new Weaver.Query()
        res = await q.find()
      catch
        history.push('gijsplorer')
      data = await loadGraphDataFromNodes(res, q)

      nodes = _.values(data.nodes).map(({ id, label, group }) ->
        { id, label, group }
      ).concat({ id: 'gijs', label: 'Gijs' })

      Graph.current = ForceGraphVR()(document.getElementById('threeD-graph'))
      Graph.current
        .graphData({ nodes, links: [] })
        .nodeResolution(20)
        .linkLabel('label')
        .linkWidth(2)
        .linkOpacity(0.2)
        .nodeOpacity(1)
        .nodeAutoColorBy('group')
        .cooldownTime(Infinity)
        .d3AlphaDecay(0.2)
        .d3VelocityDecay(0.2)

      initScene((gijs) ->
        locator.current = new GameItemLocator(
          gijs,
          ->
            setGameIsStopped(true)
        )
        locator.current.setTargetNode(
          Graph.current.graphData().nodes[0].__threeObj
        )
      )

    )()
    undefined
  , [])

  animate = (time) ->
    if !gameIsStopped
      locator.current?.tick()
      requestRef.current = requestAnimationFrame(animate);
    else
      cancelAnimationFrame(requestRef.current)

  useEffect(() ->
    requestRef.current = requestAnimationFrame(animate)
    () -> cancelAnimationFrame(requestRef.current)
  , [])

  <div id="threeD-graph" style={{ width: '100%', height: '100vh' }} />

mapStateToProps = ({
  projects: { currentProject }
}) ->
  {
    currentProject
  }

export default connect(mapStateToProps)(withRouter(Gijsplorer))
